import { CircularProgress, Stack, Typography } from "@mui/material";
import { colours } from "../../StyleConstants";

const Redirect1 = () => {
    return(
        <Stack height={"100%"} width={"100%"} justifyContent={"center"} alignItems={"center"} 
            bgcolor={ colours.midnightBlue.blue5} position={"fixed"}>
            <Typography fontSize={"24"}>
                    Document received, you will be redirected once the document is finished processing
            </Typography>
            <CircularProgress sx={{ width: "250px", height: "250px" }} />

        </Stack>
    )
}

const Redirect2 = () => {
    return(
        <Stack height={"100%"} width={"100%"} justifyContent={"center"} alignItems={"center"} 
            bgcolor={ colours.midnightBlue.blue5} position={"fixed"}>
            <CircularProgress sx={{ width: "250px", height: "250px" }} />

        </Stack>
    )
}

export { Redirect1 };

export { Redirect2 };
